//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '../../../src/lib/util';

export default {
    name: 'goodList',
    data() {
        const vm = this;
        return {
            loading: false,
            saving: false,
            name: '',
            goodType: null,
            goodTypes: [
                {
                    id: 0, value: '实物商品'
                },
                {
                    id: 1, value: '卡券商品'
                }
            ]

        };
    },
    computed: {
        goods() {
            return this.$store.state.good.list;
        },
        totalCount() {
            return this.$store.state.good.totalCount;
        },
        currentPage() {
            return this.$store.state.good.currentPage;
        },
        pageSize() {
            return this.$store.state.good.pageSize;
        }
    },
    methods: {
        imgUrl(fileId) {
            return util.ApiUrl + '/file/download/' + fileId + '?/5/w/100/h/100';
        },
        pageChange(page) {
            this.$store.commit('good/setCurrentPage', page);
            this.getPage();
        },
        pageSizeChange(pageSize) {
            this.$store.commit('good/setPageSize', pageSize);
            this.getPage();
        },
        getPage() {
            this.loading = true;
            this.$store.dispatch({
                type: 'good/getGoodAll',
                data: {
                    name: this.name,
                    goodType: this.goodType
                    // shopType: 0
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        delete(good) {

            this.$store.dispatch({
                type: 'good/delGood',
                id: good.id
            }).then(() => {
                this.$Notice.success({
                    duration: 3,
                    title: good.goodName + '已删除'
                });
                this.getPage();
            });
        },
        delGood(good) {
            // console.log(good)
            this.$Modal.confirm({
                title: '删除确认',
                content: '您确定要删除' + good.goodName + '吗？',
                onOk: () => {
                    this.delete(good);
                },
                onCancel: () => {
                }
            });
        },
        goodInfo(good) {
            this.$router.push({
                path: '/goodInfo/' + good.id
            });
        },
        editGood(good) {
            this.$router.push({
                path: '/goodEdit/' + good.id
                // name: 'goodEdit',
                // params: {
                //     id: good.id
                // }
            });
        },
        updateGoodStatus(id, status) {
            this.saving = true;
            this.$store.dispatch({
                type: 'good/updateGoodStatus',
                data: {
                    id: id,
                    status: status
                }
            }).finally(() => {
                this.getPage();
                this.saving = false;
            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.getPage();
    }

};
